import type { Operation, OperationCounts, OperationState } from '@/lib/api/schemas/operations.schema'
import { OPERATION_STATE_LABELS, OPERATION_STATE_TONES, processedCount, progressPercent } from '@/lib/operations/labels'

export function OperationStateBadge({ state }: { state: OperationState }) {
  return (
    <span data-operation-state={state} className={`inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${OPERATION_STATE_TONES[state]}`}>
      {OPERATION_STATE_LABELS[state]}
    </span>
  )
}

export function OperationProgressBar({ operation }: { operation: Pick<Operation, 'counts' | 'state'> }) {
  const percent = progressPercent(operation.counts)
  const failing = operation.counts.failed > 0
  return (
    <div className="flex items-center gap-2">
      <div
        role="progressbar"
        aria-label="Прогресс операции"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
        className="h-1.5 min-w-0 flex-1 overflow-hidden rounded-full bg-bone"
      >
        <div className={`h-full rounded-full transition-[width] duration-500 ${failing ? 'bg-st-unpaid' : 'bg-gold'}`} style={{ width: `${percent}%` }} />
      </div>
      <span className="shrink-0 text-[11px] tab-nums text-ink-muted">{processedCount(operation.counts)}/{operation.counts.total}</span>
    </div>
  )
}

export function OperationCountsSummary({ counts }: { counts: OperationCounts }) {
  return (
    <p className="flex flex-wrap gap-x-3 gap-y-0.5 text-[12px] tab-nums text-ink-2">
      <span data-count="ok">Готово: <b className="font-semibold text-received">{counts.ok}</b></span>
      <span data-count="with-warnings">из них с замечаниями: <b className="font-semibold text-gold-deep">{counts.withWarnings}</b></span>
      <span data-count="failed">Ошибки: <b className={`font-semibold ${counts.failed > 0 ? 'text-st-unpaid' : ''}`}>{counts.failed}</b></span>
      {counts.skipped > 0 ? <span data-count="skipped">Пропущено: <b className="font-semibold">{counts.skipped}</b></span> : null}
    </p>
  )
}
